module.exports = __webpack_public_path__ + "static/cart-2a86709ed18fc4f2e22906c471f173da.png";